import { routerGetCall } from '../../axios';

export const getApplicationsUrl = `/accounts/applications`;
const getDigitalSalesApplications = (state, params) => {
  const url = getApplicationsUrl;
  return routerGetCall(state, url, params);
};
export default { getDigitalSalesApplications };
